import React from "react";

const MyDriversIcon = ({
  width = "16",
  height = "16",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_620_22583)">
        <path
          d="M7.25 11.5312V14.4563C4.17812 14.1031 1.75625 11.6062 1.51875 8.5H4.8875L7.20937 11.4844C7.22187 11.5 7.23438 11.5156 7.25 11.5312ZM8.75 11.5312C8.7625 11.5156 8.77812 11.5 8.79062 11.4844L11.1125 8.5H14.4812C14.2437 11.6062 11.825 14.1031 8.75 14.4563V11.5312ZM11 7L10.775 6.55312C10.6062 6.21562 10.2594 6 9.88125 6H6.11875C5.74062 6 5.39375 6.2125 5.225 6.55312L5 7H1.575C2.05625 3.88438 4.75 1.5 8 1.5C11.25 1.5 13.9438 3.88438 14.425 7H11ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_620_22583">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MyDriversIcon;
